import React, { useState } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import * as Yup from 'yup'
import { Alert, Button } from 'components/Elements'
import { FormFieldController, TextInput, PasswordInputFiled } from 'components/FormElements'
import { useNotify } from 'hooks'
import { ValidationsUtils } from 'utils'

const passwordMinLength = 8

export const LoginForm = props => {
  const { t } = useTranslation()

  const { showNotification } = useNotify()

  const {
    control,
    handleSubmit,
    setError,
    clearErrors,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
    resolver: yupResolver(
      Yup.object().shape({
        email: Yup.string().email('field.error.invalid').required('field.error.required'),
        password: Yup.string()
          .required('field.error.required')
          .min(passwordMinLength, 'field.error.password.length'),
      })
    ),
  })

  const [alertError, setAlertError] = useState(null)
  const [submittedEmail, setSubmittedEmail] = useState(null)

  const onSubmit = async data => {
    setAlertError(null)
    setSubmittedEmail(data.email)
    try {
      await props.onSubmit(data)
    } catch (error) {
      setAlertError(error)
      ValidationsUtils.setServerSideErrors(error?.errors, setError)
    }
  }

  const onSendVerifyEmail = async e => {
    e.preventDefault()
    setAlertError(null)
    clearErrors()

    if (submittedEmail) {
      try {
        await props.onVerifyEmail(submittedEmail)
        showNotification({
          type: 'success',
          message: t('confirmation-email-sent'),
        })
      } catch (error) {
        const message = error?.message || t('error')
        showNotification({
          type: 'error',
          message,
        })
      }
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        {alertError && <Alert type={'error'}>{alertError?.message || t('error')}</Alert>}

        {alertError && alertError?.errors?.unverified_email && (
          <div className="mt-4">
            <p className={'font-weight-medium'}>
              <a href="#" onClick={onSendVerifyEmail} className={'font-weight-medium text-primary'}>
                {t('send_confirmation_email_to')}
              </a>
              {` ${submittedEmail}`}
            </p>
          </div>
        )}

        <FormFieldController
          name={'email'}
          control={control}
          component={TextInput}
          id={'email'}
          label={t('email')}
          placeholder={t('email')}
        />

        <FormFieldController
          name={'password'}
          control={control}
          component={PasswordInputFiled}
          id={'password'}
          label={t('password')}
          placeholder={t('password')}
          translateParams={{ count: passwordMinLength }}
        />

        <div className={'text-end'}>
          <Link to={'/forgot-password'}>{t('forgot_password')}?</Link>
        </div>

        <div className={'text-center mt-4'}>
          <Button type={'submit'} disabled={isSubmitting} loading={isSubmitting}>
            {t('login')}
          </Button>
        </div>
      </form>
    </>
  )
}
